import React from "react";
import { Grid } from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import { useSelector } from "react-redux";
import DeleteIcon from "../../../commonComponents/deleteIcon";
import CopyRepElement from "../itemsTab/copyRepElement";
import { useCurrentShipmentType } from "../../../hooks";

function AdditionalSupplyChainActorDetails({item:{id,type,eoriNo,roleId,invoiceActorRoleId},deleteData,updateData,saveData,isItemTab,copyData,isFormDisabled=false}){
 
  const additionSupplyChainActorType= useSelector((state) => state.DropDownValues.additionSupplyChainActorType);
  const {isDisabled} = useCurrentShipmentType()
  return (
    <Grid.Row>
      {isItemTab && (
        <Grid.Column width={1} style={{textAlign:'center'}}>
        <CopyRepElement 
            title={`ADDITIONAL SUPPLY CHAIN ACTOR`}
            request={{type,eoriNo}}
            callback={copyData}
            isFormDisabled={isDisabled}
         />
      </Grid.Column>
      )}
      <Grid.Column
        width="5"
        className="divFormFeild border-bottom b-rw-0"
      >
        <DropDown
           id={`supplyType-${id}`}
          label="Type"
          disabled={isFormDisabled}
          boxNumber="3/37"
          className="field-bg dropdown100 addInfoCode"
          labelClass="text-none"
          isLabel={true}
          data={additionSupplyChainActorType}
          value={type}
          clearable
          onChange={(value) => {
            saveData({id,type:value,roleId,invoiceActorRoleId})
            updateData(id,{"type":value?.trim()})}
          
          }
        />
      </Grid.Column>
      <Grid.Column
        width={isItemTab?'9':'10'}
        className="divFormFeild  border-bottom"
      >
        <InputField
          isLabel={false}
          id={`supplyIdentify-${id}`}
          type="text"
          label="IDENTIFICATION"
          boxNumber="3/37"
          value={eoriNo}
          className="field-bg"
          clearInput={false}
          onChange={(value) =>updateData(id,{"eoriNo":value})}
          onBlur={(value) =>saveData({id,eoriNo:eoriNo||' ',roleId,invoiceActorRoleId})}
          disabled={isFormDisabled}
        />
      </Grid.Column>
     
      <Grid.Column width="1" className="icon-delete-add-info">
        <DeleteIcon id={`deleteSupChainActor-${id}`} onClick={() =>deleteData(id)} disabled={isFormDisabled} />
        
      </Grid.Column>
    </Grid.Row>
  );
}

export default React.memo(AdditionalSupplyChainActorDetails)
